var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{staticClass:"no-data-img",attrs:{"src":require("@/assets/images/no-data.png"),"alt":""}}),_c('div',{staticClass:"no-data-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }